// src/pages/agenda/VisaoMes.js — visão Mês.
//
// Até 3 compromissos por dia ("+N mais" no resto); clicar no dia abre a
// visão Dia. No celular cada dia vira só o número com pontinhos coloridos
// por tipo — 7 colunas de 44px não comportam texto.
import { Box } from '@mui/material';
import { DC, dnum, gradeDoMes } from './datas';
import { FONT_NUM, LILAS, TIPOS, botaoBase, cor, ehProposta } from './estilo';

const LIMITE = 3;

export default function VisaoMes({ cursor, hoje, porDia, selId, onSel, onDia, compacto }) {
  const { dias, n } = gradeDoMes(cursor);
  const mes = cursor.slice(0, 7);
  return (
    <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(7, minmax(0, 1fr))', borderBottom: '1px solid var(--ch-bdr)', flex: 'none' }}>
        {DC.map((c) => (
          <Box key={c} component="span" sx={{ p: compacto ? '8px 0' : '8px 10px', textAlign: compacto ? 'center' : 'left', fontSize: '0.62rem', fontWeight: 700, letterSpacing: '0.1em', color: 'var(--ch-text3)' }}>{c}</Box>
        ))}
      </Box>
      <Box sx={{ flex: 1, minHeight: compacto ? 0 : 420, display: 'grid', gridTemplateColumns: 'repeat(7, minmax(0, 1fr))', gridTemplateRows: `repeat(${n / 7}, minmax(${compacto ? 52 : 0}px, 1fr))` }}>
        {dias.map((s) => {
          const outro = s.slice(0, 7) !== mes;
          const ehHoje = s === hoje;
          const lista = porDia[s] || [];
          const numero = (
            <Box component="span" sx={{ alignSelf: compacto ? 'center' : 'flex-start', minWidth: 22, height: 22, boxSizing: 'border-box', px: '5px', borderRadius: '11px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: FONT_NUM, fontSize: '0.75rem', fontWeight: 600, color: ehHoje ? 'var(--ch-on-green)' : outro ? 'var(--ch-text3)' : 'var(--ch-text)', bgcolor: ehHoje ? 'var(--ch-green)' : 'transparent' }}>
              {dnum(s)}
            </Box>
          );
          return (
            <Box key={s} role="button" tabIndex={0} onClick={() => onDia(s)}
              onKeyDown={(e) => { if (e.key === 'Enter') onDia(s); }}
              aria-label={`${dnum(s)}: ${lista.length} compromisso${lista.length === 1 ? '' : 's'}`}
              sx={{ ...botaoBase, minHeight: 0, minWidth: 0, overflow: 'hidden', borderRight: '1px solid var(--ch-bdr)', borderBottom: '1px solid var(--ch-bdr)', bgcolor: outro ? 'var(--ch-surf)' : 'var(--ch-card)', p: compacto ? '5px 2px' : '5px 6px', display: 'flex', flexDirection: 'column', gap: '2px' }}>
              {numero}
              {compacto ? (
                <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '3px', px: '2px' }}>
                  {lista.slice(0, 4).map((e) => (
                    <Box key={e.id} component="span" sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: ehProposta(e) ? 'transparent' : cor(TIPOS[e.tipo].c).base, border: ehProposta(e) ? `1.5px dashed ${LILAS}` : 'none', boxSizing: 'border-box' }} />
                  ))}
                  {lista.length > 4 && <Box component="span" sx={{ fontFamily: FONT_NUM, fontSize: '0.55rem', color: 'var(--ch-text2)', lineHeight: '6px' }}>+</Box>}
                </Box>
              ) : (
                <>
                  {lista.slice(0, LIMITE).map((e) => (
                    <Box key={e.id} role="button" tabIndex={0}
                      onClick={(ev) => { ev.stopPropagation(); onSel(e.id); }}
                      onKeyDown={(ev) => { if (ev.key === 'Enter') { ev.stopPropagation(); onSel(e.id); } }}
                      aria-label={ehProposta(e) ? `Proposta do Copiloto: ${e.ini} ${e.titulo}` : undefined}
                      sx={{ display: 'flex', alignItems: 'center', gap: '5px', p: '1px 5px', borderRadius: '5px', minWidth: 0, boxShadow: selId === e.id ? '0 0 0 1.5px var(--ch-bdr2)' : 'none', border: ehProposta(e) ? `1px dashed ${LILAS}` : '1px solid transparent', bgcolor: ehProposta(e) ? 'var(--cp-tint)' : 'transparent', '&:hover': { bgcolor: 'var(--ch-inset)' } }}>
                      <Box component="span" sx={{ width: 6, height: 6, flexShrink: 0, borderRadius: '50%', bgcolor: ehProposta(e) ? LILAS : cor(TIPOS[e.tipo].c).base }} />
                      <Box component="span" sx={{ fontSize: '0.65rem', color: ehProposta(e) ? 'var(--cp-claro)' : 'var(--ch-text)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        <Box component="span" sx={{ fontFamily: FONT_NUM, color: 'var(--ch-text2)', mr: '3px' }}>{e.ini}</Box>{e.titulo}
                      </Box>
                    </Box>
                  ))}
                  {lista.length > LIMITE && (
                    <Box component="span" sx={{ fontSize: '0.65rem', fontWeight: 600, color: 'var(--ch-text2)', pl: '5px' }}>+{lista.length - LIMITE} mais</Box>
                  )}
                </>
              )}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}
